import { CellFieldV2 as CellField, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import type { DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';
import { hoaDonSearchColumns, QUERY_KEYS } from '@/constants';

import { FormMode } from '@/types/form';

export const getAdvSettlementTableColumns = (
  formMode: FormMode,
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void
) => [
  // id_chi - ID chi
  {
    field: 'id_chi',
    headerName: 'ID Chi',
    width: 100,
    renderCell: (params: DataTableRenderCellParams) => (
      <SearchField<MuaHangRecord>
        type='text'
        searchEndpoint={`/${QUERY_KEYS.HOA_DON}/`}
        searchColumns={hoaDonSearchColumns}
        columnDisplay='id'
        dialogTitle='Hoá đơn'
        value={params.row.id_chi_data?.id || ''}
        onRowSelection={(row: MuaHangRecord) => onCellValueChange(params.row.uuid, 'id_chi_data', row)}
        disabled={formMode === 'view'}
      />
    ),
    pasteConfig: {
      lookupKey: 'id_chi',
      resultField: 'id_chi_data',
      detailEndpoint: QUERY_KEYS.HOA_DON
    }
  },
  // so_ct_chi - Số chứng từ chi
  {
    field: 'so_ct_chi',
    headerName: 'Số chứng từ',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => (
      <CellField
        commitOnBlur
        name='so_ct_chi'
        type='text'
        value={params.row.id_chi_data?.so_ct || ''}
        disabled={formMode === 'view'}
      />
    ),
    nonWritable: true
  },
  // ngay_ct_chi - Ngày chứng từ chi
  {
    field: 'ngay_ct_chi',
    headerName: 'Ngày chứng từ',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => (
      <CellField
        commitOnBlur
        name='ngay_ct_chi'
        type='date'
        value={params.row.id_chi_data?.ngay_ct || ''}
        disabled={formMode === 'view'}
      />
    ),
    nonWritable: true
  },
  // tien_nt - Tiền ngoại tệ
  {
    field: 'tien_nt',
    headerName: 'Tiền VND',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => (
      <CellField
        commitOnBlur
        name='tien_nt'
        type='number'
        value={params.row.id_chi_data?.tien_nt || 0.0}
        disabled={formMode === 'view'}
      />
    ),
    nonWritable: true
  },
  // ma_ct - Mã chứng từ
  {
    field: 'ma_ct',
    headerName: 'Mã chứng từ',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => (
      <CellField name='ma_ct' type='text' value={params.row.id_chi_data?.ma_ct || ''} disabled={formMode === 'view'} />
    ),
    nonWritable: true
  }
];
